module.exports = __webpack_public_path__ + "img/background9.d40f8086.jpg";